import React from 'react';
import useResponsibleGamingTextByCountry from "../../hooks/useResponsibleGamingTextByCountry";
import PickXProvincesAndTerritories from "../../components/PickXProvincesAndTerritories/PickXProvincesAndTerritories";
import PayoutDistributionTable from "../../components/PayoutDistributionTable/PayoutDistributionTable";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import GlobalConst from "../../constants/GlobalConst";

const TermsOfUseFr = () => {
    const responsibleGamingTexts = useResponsibleGamingTextByCountry();
    const host = window.location.origin;
    return (
        <div className="terms-container">
            <h1>Conditions d'utilisation de TradeFan PickX</h1>
            <p><strong>Dernière mise à jour : 1er octobre 2024</strong></p>
            <br/>
            <p>IMPORTANT ! VEUILLEZ LIRE ATTENTIVEMENT CES CONDITIONS D'UTILISATION DE TRADEFAN PICKX AVANT D'UTILISER
                LES SERVICES DE TRADEFAN PICKX, CAR CES CONDITIONS AFFECTENT VOS DROITS ET OBLIGATIONS LÉGAUX. LES
                ACCORDS (TEL QUE DÉFINIS DANS LA SECTION INTRODUCTION) SONT SOUMIS À UNE RENONCIATION AU DROIT DE PROCÈS
                PAR JURY.</p>
            <br/>
            <section id="introduction">
                <p><strong>INTRODUCTION</strong></p>
                <p>
                    TradeFan PickX est un format de concours de sports fantastiques quotidien proposé par 8710031 Canada
                    Inc.
                    (« <strong>TradeFan</strong> »
                    ou « <strong>Société</strong> ») où les participants peuvent gagner en sélectionnant si leurs
                    athlètes choisis dépasseront une projection statistique lors d'événements sportifs réels (« <strong>Pick
                    Set</strong> »). TradeFan possède et exploite le site web <a
                    href={host}>{host}</a> (le
                    « Site Web ») et, une fois lancé, l'application mobile TradeFan
                    PickX (« <strong>Application Mobile</strong> », et l'Application Mobile avec le Site Web, la
                    « <strong>Plateforme TradeFan</strong> »). Ces Conditions d'utilisation de TradeFan PickX (les
                    « <strong>Conditions d'utilisation</strong> ») régissent tous les aspects de votre accès et
                    utilisation de la Plateforme TradeFan ; la soumission de toute entrée via la Plateforme TradeFan ;
                    et les concours, contenus, produits, fonctionnalités, outils, promotions et autres services proposés
                    via la Plateforme TradeFan (collectivement, les « <strong>Services</strong> »).
                </p>
            </section>
            <br/>
            <section id="agreement">
                <p><strong>ACCORD D'ÊTRE LIÉ</strong></p>
                <p>
                    En visitant le Site Web ou en téléchargeant l'Application Mobile, dans chaque cas, que vous créiez
                    ou non un Compte (tel que défini dans la section Âge et Localisation Physique ci-dessous), que vous
                    vous inscriviez aux Services, et/ou que vous utilisiez les Services, vous acceptez d'être lié par
                    ces Conditions d'utilisation ; l'avis de confidentialité de TradeFan disponible en cliquant <a
                    href={host+"/PrivacyPolicy"}>ici</a>
                    (l'« <strong>Avis de Confidentialité</strong> ») ; ainsi que toutes les autres règles, termes et
                    conditions, politiques et avis applicables à la Plateforme TradeFan, aux Services ou à toute offre,
                    promotion ou prime proposée sur ou via la Plateforme TradeFan ou les Services, qui sont publiés sur
                    ou via la Plateforme TradeFan ou les Services ou qui vous sont autrement communiqués, et qui peuvent
                    être modifiés à tout moment, tous étant incorporés par référence dans leur intégralité aux présents
                    accords (les « Autres Termes », et avec les Conditions d'utilisation, les « Accords »). Les Accords
                    ne s'appliquent pas à ou ne régissent pas votre utilisation d'autres produits et/ou services fournis
                    par TradeFan ou ses affiliés, y compris, sans limitation, les concours de sports fantastiques
                    TradeFan Trading.
                </p>
                <p>AU CAS OÙ VOUS NE CONSENTEZ PAS À ÊTRE LIÉ PAR TOUS LES TERMES ET CONDITIONS DES ACCORDS SANS
                    MODIFICATION, N'UTILISEZ PAS OU N'ACCÉDEZ PAS À LA PLATEFORME TRADEFAN OU AUX SERVICES. Les Accords
                    constituent un accord juridique entre vous et TradeFan et s'appliqueront à votre accès et
                    utilisation de la Plateforme TradeFan et des Services, même après la fermeture de votre Compte, la
                    résiliation de l'offre des Services ou la résiliation de l'un ou de tous les droits qui vous sont
                    accordés en vertu des Accords.</p>
            </section>
            <br/>
            <section id="age-location">
                <p><strong>ÂGE ET LOCALISATION PHYSIQUE</strong></p>
                <p>
                    Pour créer un compte sur la Plateforme TradeFan (« <strong>Compte</strong> »), utiliser les
                    Services, participer aux concours proposés via les Services (les « <strong>Concours</strong> ») ou
                    recevoir des prix de la Plateforme TradeFan et/ou des Services, vous devez être, et vous affirmez
                    que vous êtes, âgé d'au moins dix-huit (18) ans. Cependant, si vous êtes physiquement situé en
                    Alabama ou au Nebraska, vous devez être âgé d'au moins dix-neuf (19) ans, ou si vous êtes en Arizona
                    ou au Massachusetts, vous devez être âgé d'au moins vingt et un (21) ans. Il peut être considéré
                    comme une infraction pénale ou civile pour toute personne d'utiliser les Services ou de permettre à
                    d'autres d'utiliser les Services si elle ne respecte pas ces exigences d'âge.
                </p>
                <p>
                    Seules les personnes physiquement situées dans les juridictions énumérées sur la Plateforme TradeFan
                    Où pouvez-vous jouer à TradeFan Pick6 ? (« <strong>Juridictions Éligibles</strong> ») peuvent créer
                    un Compte et utiliser les Services. Ces Conditions d'utilisation incluent, par référence, la liste
                    des Juridictions Éligibles disponible sur <a href={host+"/#where-is-PickX-available"}>{host}/#where-is-PickX-available</a>.
                    TradeFan se réserve le droit de mettre à jour, modifier ou ajuster ces pages web ou listes de
                    Juridictions Éligibles à sa seule discrétion, à tout moment, et sans préavis.
                </p>
                <p>
                    Si vous êtes situé en dehors d'une Juridiction Éligible, vous pouvez être en mesure d'accéder et de
                    visualiser la Plateforme TradeFan, mais vous êtes interdit d'utiliser les Services, y compris de
                    participer à des Concours. Si vous utilisez les Services alors que vous êtes en dehors des
                    Juridictions Éligibles, toute action que vous entreprenez, y compris votre participation à des
                    Concours, est nulle, et tout prix que vous pourriez gagner est invalide. Ces prix seront confisqués
                    et déduits de votre solde de Compte. Si vous avez déjà retiré ces prix confisqués de votre Compte,
                    vous acceptez de les retourner immédiatement sur demande.
                </p>
                <p>
                    Ces Conditions d'utilisation régissent votre accès et utilisation de la Plateforme TradeFan, y
                    compris tout contenu, lorsque vous accédez ou utilisez la Plateforme TradeFan depuis l'extérieur des
                    Juridictions Éligibles. Vous acceptez également de respecter toutes les lois applicables de la
                    juridiction dans laquelle vous vous trouvez lorsque vous accédez et/ou utilisez la Plateforme
                    TradeFan et/ou les Services.
                </p>
                <p>
                    En accédant ou en utilisant les Services, vous déclarez, garantissez et convenez que :
                    <ol>
                        <li>
                            <strong>Conformité Juridictionnelle : </strong>Vous vous trouvez dans une juridiction où
                            l'utilisation
                            des Services, y compris la participation à des Concours, est autorisée par la loi, et vous
                            avez
                            vérifié que votre utilisation des Services est conforme à toutes les lois, règlements et
                            règles
                            applicables dans votre lieu de résidence.
                        </li>
                        <li>
                            <strong>Légalité de la Participation : </strong>Vous déclarez et garantissez également que
                            votre
                            utilisation des Services, y compris mais sans s'y limiter, l'accès à la Plateforme, la
                            participation
                            aux Concours et la réception de prix, ne viole aucune restriction légale dans votre
                            juridiction, y compris mais sans s'y limiter, les lois relatives aux jeux de hasard, aux
                            paris, aux concours d'habileté ou aux loteries.
                        </li>
                        <li>
                            <strong>Responsabilité de la Conformité : </strong>Il est de votre seule responsabilité de
                            comprendre
                            et de respecter les lois, règles et règlements applicables dans votre juridiction. TradeFan
                            ne fournit aucune garantie et ne fournira aucune assurance quant à la légalité de votre
                            participation
                            aux Services dans une juridiction donnée.
                        </li>
                        <li>
                            <strong>Restrictions d'Accès : </strong>Si à tout moment il est déterminé que vous avez
                            accédé ou utilisé
                            les Services à partir d'une juridiction où un tel accès ou utilisation est interdit, ou si
                            TradeFan
                            détermine, à sa seule discrétion, que vous violez les lois applicables ou ces Accords,
                            TradeFan se réserve le droit de suspendre ou de résilier immédiatement votre Compte et
                            l'accès aux Services sans préavis, et vous acceptez de renoncer à tout prix ou avantage qui
                            aurait pu être gagné.
                        </li>
                        <li>
                            <strong>Preuve d'Éligibilité : </strong>À la demande de TradeFan, vous acceptez de fournir
                            la preuve
                            de votre conformité avec les lois et règlements de votre juridiction, y compris des
                            documents prouvant votre emplacement physique et toute licence ou autorisation pouvant être
                            requise.
                        </li>
                    </ol>
                </p>
            </section>
            <br/>
            <section id="account">
                <p><strong>VOTRE COMPTE</strong></p>
                <p>
                    TradeFan se réserve le droit de refuser votre demande de création de Compte à sa seule discrétion,
                    pour
                    toute raison ou sans aucune raison. Lorsque vous créez un Compte ou utilisez les Services, il se
                    peut que
                    le sol puisse vous demander de fournir des informations spécifiques, y compris, mais sans s'y
                    limiter, votre nom légal complet, votre date de naissance, votre numéro de sécurité sociale, un
                    autre numéro d'identification fiscale, votre adresse physique, votre adresse e-mail et tous les
                    autres détails ou documents nécessaires pour vérifier votre identité et votre éligibilité. Si
                    TradeFan vous demande des informations supplémentaires, vous devez immédiatement fournir des détails
                    précis et complets, et il est de votre responsabilité de les mettre à jour si nécessaire. TradeFan
                    peut demander plus d'informations ou de documents à tout moment, à sa discrétion, y compris avant
                    que vous participiez à un concours, effectuiez un dépôt ou un retrait, ou réclamiez un prix. Cela
                    est fait pour vérifier votre identité et garantir que vous remplissez les critères d'éligibilité.
                </p>
                <p>
                    Tant que vous n'avez pas fourni les informations demandées, ou si vous ne le faites pas
                    immédiatement, TradeFan peut, sans limitation, retenir les prix, restreindre votre capacité à
                    effectuer des dépôts ou des retraits, suspendre votre compte ou même le fermer. Vous acceptez de
                    permettre à TradeFan de vérifier votre âge et votre identité. En cas de questions, litiges ou
                    préoccupations concernant votre identité ou votre éligibilité, TradeFan peut utiliser certaines
                    informations recueillies auprès de vous à sa discrétion pour aider à vérifier ces détails.
                </p>
                <p>
                    Vous n'êtes autorisé à créer qu'un seul compte. Vous ne pouvez pas utiliser ou accéder au compte de
                    quelqu'un d'autre, avec ou sans son consentement, ni permettre à quelqu'un d'autre d'utiliser ou
                    d'accéder à votre compte. Cela inclut, mais sans s'y limiter, la participation à des concours au nom
                    de quelqu'un d'autre, l'utilisation du compte de quelqu'un d'autre pour des concours, l'accès aux
                    détails du Pick Set, du concours ou du compte de quelqu'un d'autre, ou permettre à quelqu'un d'autre
                    de faire l'une de ces choses avec votre compte. Si TradeFan croit, pour quelque raison que ce soit,
                    que vous avez ouvert plus d'un compte, que vous avez permis à quelqu'un d'autre d'accéder à votre
                    compte ou que vous utilisez le compte de quelqu'un d'autre, TradeFan se réserve le droit de
                    suspendre ou de résilier n'importe lequel ou l'ensemble de vos comptes. Il peut également annuler
                    toute participation en attente à des concours ou retenir, révoquer ou annuler tout prix qui vous a
                    été attribué.
                </p>
                <p>
                    Ces Conditions d'utilisation s'appliquent également si vous accédez au compte de quelqu'un d'autre,
                    même si vous n'avez pas votre propre compte. Un tel accès sera considéré comme une violation des
                    Conditions. Vous ne pouvez pas ouvrir un compte au nom de quelqu'un d'autre, en particulier si cette
                    personne est interdite par la loi ou par ces Conditions d'ouvrir un compte ou d'utiliser les
                    Services.
                </p>
                <p>
                    En utilisant les Services, vous acceptez que TradeFan, ses affiliés et ses prestataires de services
                    tiers
                    puissent surveiller et enregistrer vos communications et votre localisation géographique. Vous
                    consentez également à ce que TradeFan signale l'activité de votre compte ou vos gains de prix aux
                    autorités locales, étatiques et fédérales applicables, conformément aux lois en vigueur.
                </p>
            </section>
            <br/>
            <section id="loginPassword">
                <p><strong>CONNEXION AU COMPTE ET MOT DE PASSE</strong></p>
                <p>
                    Vous êtes responsable de la confidentialité de votre nom d'utilisateur et de votre mot de passe de
                    compte et ne devez les partager avec personne. Vous vous engagez à faire tous les efforts pour
                    protéger vos informations de connexion, y compris en utilisant un mot de passe unique pour votre
                    compte et en désactivant toutes les options du navigateur qui stockent ou remplissent
                    automatiquement les mots de passe. Vous devez également changer régulièrement votre mot de passe, et
                    vous pouvez trouver des instructions pour le faire [ici]. De plus, vous devez verrouiller les
                    appareils que vous utilisez pour accéder à la plateforme TradeFan.
                </p>
                <p>
                    Vous êtes responsable de toutes les actions, frais et dommages qui se produisent sous votre compte,
                    qu'ils soient autorisés par vous ou non. Si vous pensez que quelqu'un d'autre utilise votre compte,
                    contactez-nous immédiatement à support@TradeFan.com. TradeFan n'est pas responsable des pertes,
                    frais ou dommages dus à un accès non autorisé à votre compte ou à votre échec à nous en informer,
                    que vous en soyez conscient ou non.
                </p>
                <p>
                    Vous acceptez d'indemniser et de dégager de toute responsabilité TradeFan, ses sociétés mères,
                    filiales, affiliés, successeurs, ayants droit, dirigeants, directeurs, employés, agents,
                    contractuels, actionnaires et représentants (collectivement, les « Parties Libérées de TradeFan »)
                    contre toute réclamation, action en justice, responsabilité, coûts, pertes et dépenses (y compris
                    les honoraires d'avocats, les frais judiciaires et autres frais légaux). Cela inclut les frais
                    découlant des procès, des appels ou des procédures de faillite, ainsi que des dommages résultant de
                    l'accès de tiers à votre compte, qu'un tel accès soit autorisé ou non, et que ce soit dû à votre
                    violation des lois, à une négligence, à des actions délibérées ou à une violation des présents
                    accords.
                </p>
            </section>
            <br/>
            <section id="deposits">
                <p><strong>DÉPÔTS</strong></p>
                <p>
                    Votre compte peut être financé par divers moyens de dépôt, en fonction de votre emplacement physique
                    au moment du dépôt. TradeFan accepte les principales cartes de débit et, selon votre emplacement,
                    peut également accepter les principales cartes de crédit.
                </p>
                <p>
                    Vous confirmez que vous êtes le propriétaire légal du mode de paiement utilisé pour les dépôts et
                    les retraits et que les fonds ne sont pas liés à une activité illégale. L'utilisation d'un mode de
                    paiement que vous ne possédez pas légalement ou le dépôt de fonds liés à une activité illégale
                    constitue une violation de ces Conditions d'utilisation.
                </p>
                <p>
                    Vous acceptez de ne pas inverser (ou "contester") un dépôt effectué sur votre compte, y compris via
                    des tiers. Si un dépôt est contesté, annulé, échoue ou n'est pas honoré par votre institution
                    financière, TradeFan peut immédiatement restreindre l'accès à votre compte. Tout prix, récompense,
                    crédit ou bonus associé à ces dépôts sera invalidé et déduit du solde de votre compte. Vous acceptez
                    également de retourner les fonds que vous avez retirés et qui sont associés à un dépôt annulé ou
                    contesté.
                </p>
                <p>
                    Si votre dépôt est contesté ou annulé, ou ne se règle pas, TradeFan se réserve le droit de (i)
                    déduire le montant du dépôt de votre compte, (ii) suspendre ou fermer votre compte, et/ou (iii)
                    récupérer les fonds par tout autre moyen, comme utiliser une agence de recouvrement (ce qui pourrait
                    affecter négativement votre cote de crédit). Vous êtes responsable du remboursement à TradeFan de
                    tout coût, frais ou pénalité liés aux contestations ou annulations de dépôts, y compris les frais
                    juridiques et les dépenses de recouvrement.
                </p>
                <p>
                    Si vous estimez que vos fonds ont été mal gérés, vous pouvez déposer une plainte par e-mail à <a
                    href="mailto:support@TradeFan.com">support@TradeFan.com</a>. TradeFan tentera de répondre à votre
                    plainte dans un délai de dix (10) jours ouvrables. Si la plainte n'est pas résolue en votre faveur,
                    TradeFan expliquera les raisons. Si des informations supplémentaires sont nécessaires pour traiter
                    votre plainte, TradeFan vous informera des détails supplémentaires requis.
                </p>
            </section>
            <br/>
            <section id="conditionsParticipation">
                <p><strong>CONDITIONS DE PARTICIPATION</strong></p>
                <p>
                    Vous n'êtes pas autorisé à utiliser la plateforme TradeFan ou ses services, y compris participer à
                    des concours, si
                    l'une des conditions suivantes s'applique :
                </p>
                <ul>
                    <li>Les lois, règles, règlements ou autres actes autorisés de la juridiction où vous vous trouvez
                        physiquement
                        ne vous permettent pas d'utiliser les Services.
                    </li>
                    <li>Votre utilisation enfreint les règles de la plateforme TradeFan.</li>
                    <li>Vous avez accédé à des informations confidentielles ou non publiées qui vous donnent un avantage
                        injuste,
                        comme connaître les résultats des événements ou des détails privés provenant d'une instance
                        dirigeante sportive.
                    </li>
                    <li>Vous ou un membre de votre famille immédiate (une personne vivant avec vous, comme un
                        partenaire, un parent ou
                        un frère/sœur) (un « Membre de la Famille Immédiate ») travaillez pour une entreprise de sport
                        fantasy ou un
                        site similaire qui offre des frais d'inscription ou des prix.
                    </li>
                    <li>Vous figurez sur une liste d'exclusion d'état pour les sports fantasy quotidiens ou les jeux.
                    </li>
                    <li>TradeFan décide que votre participation compromet l'équité de tout concours.</li>
                    <li>Votre participation viole des règles établies par votre employeur ou une organisation sportive,
                        comme des
                        règles concernant l'acceptation de prix.
                    </li>
                    <li>Un tribunal ou un organisme de réglementation vous a interdit d'utiliser le service, ou son
                        utilisation
                        violerait des lois ou règlements dans votre région.
                    </li>
                </ul>
                <p>
                    Vous ne pouvez pas utiliser la plateforme TradeFan ou ses services pour tout jeu, match ou événement
                    organisé par
                    une organisation sportive avec laquelle vous êtes lié si vous êtes un athlète, joueur, agent,
                    entraîneur,
                    arbitre, propriétaire d'équipe, ou tout autre officiel (comme un médecin ou un entraîneur)
                    travaillant avec l'équipe.
                    Cela s'applique également si vous êtes un employé, consultant, contractuel ou un Membre de la
                    Famille Immédiate
                    de ces individus.
                </p>
                <p>
                    Les employés de TradeFan et leurs Membres de la Famille Immédiate ne sont pas autorisés à participer
                    à des concours
                    publics (sauf à des fins de test). Cependant, ils sont autorisés à participer à des concours privés,
                    y compris ceux
                    organisés par TradeFan, pour de l'argent ou d'autres prix. Un « Concours Privé » est un concours qui
                    n'est pas
                    répertorié publiquement sur la plateforme TradeFan et est organisé par un autre employé de TradeFan
                    ou leurs
                    familles, amis ou proches.
                </p>
                <p>
                    TradeFan peut suspendre votre compte, vous retirer des concours, retenir des prix ou vous demander
                    de restituer
                    des prix si elle découvre ou estime que vous avez enfreint leurs règles. Ils ont le dernier mot à ce
                    sujet et
                    n'ont pas besoin d'une raison spécifique. Les violations incluent :
                </p>
                <ul>
                    <li>Commettre une fraude, comme manipuler des Concours ou des ensembles de choix, tricher, fraude
                        financière ou
                        utilisation non autorisée de crédit.
                    </li>
                    <li>Agir de manière déloyale, nuisible aux Services de TradeFan ou négative pour les autres
                        utilisateurs.
                    </li>
                    <li>Faire quoi que ce soit qui porte atteinte à la réputation de TradeFan ou nuit à leur
                        entreprise.
                    </li>
                    <li>Essayer d'influencer les résultats de jeux ou de Concours de manière injuste, seul ou avec
                        d'autres.
                    </li>
                    <li>Travailler avec d'autres pour manipuler les Ensembles de choix ou les Concours.</li>
                    <li>Utiliser des outils automatisés tels que des bots ou des scripts pour interagir avec la
                        plateforme TradeFan,
                        entrer dans des concours ou collecter des données.
                    </li>
                    <li>Profiter des retards dans la mise à jour des informations ou des statistiques.</li>
                    <li>Utiliser la plateforme TradeFan à des fins autres que personnelles ou la partager avec d'autres
                        à des fins
                        commerciales.
                    </li>
                    <li>Abuser des bonus, programmes de parrainage ou promotions.</li>
                    <li>Exploiter des erreurs évidentes ou des bugs dans le système.</li>
                    <li>Altérer, contourner ou manipuler les systèmes, la sécurité ou les contrôles de risque de
                        TradeFan.
                    </li>
                    <li>Collecter des informations auprès d'autres utilisateurs à quelque fin que ce soit.</li>
                </ul>
            </section>
            <br/>
            <section id="contestEntry">
                <p><strong>INSCRIPTION AUX CONCOURS</strong></p>
                <p>
                    Il est important que vous lisiez et compreniez les règles et procédures de tout concours auquel vous
                    participez.
                    Ces règles, y compris toute mise à jour, sont intégrées dans leur intégralité aux présentes
                    Conditions d'utilisation
                    par référence. Vous pouvez trouver plus de détails sous l'onglet Règles des Concours sur la page du
                    concours ou
                    dans la section TradeFan PickX du Centre d'aide/FAQ. Elles sont intégrées dans leur intégralité aux
                    présentes
                    Conditions d'utilisation par référence, y compris les modifications apportées à tout moment.
                    TradeFan et ses
                    parties liées ne sont pas responsables si vous rejoignez un concours sans comprendre pleinement les
                    règles et
                    procédures.
                </p>
                <p>
                    La participation à chaque concours doit se faire uniquement comme spécifié dans les Accords.
                    TradeFan Pick-X est
                    un concours où les participants peuvent gagner en choisissant si leurs athlètes choisis dépasseront
                    ou non une
                    projection statistique lors d'événements sportifs réels. Dans Pick-X, les participants peuvent
                    constituer des
                    compositions d'entre 3 et 8 joueurs. Entrez vos choix pour participer à des concours et gagner des
                    prix en
                    argent en obtenant le nombre requis de choix corrects. Après avoir créé votre Ensemble de choix,
                    vous devrez
                    entrer le montant total des frais d'inscription pour lequel vous souhaitez jouer. Vous pouvez le
                    faire en
                    tapant directement le montant total en dollars. Les frais d'inscription doivent être des montants en
                    dollars
                    entiers. Lorsque vous êtes prêt, passez à l'écran de finalisation pour examiner votre Ensemble de
                    choix et les
                    montants de prix estimés avant de soumettre.
                </p>
                <p>
                    Les Ensembles de choix sont créés en choisissant des paris parmi une sélection d'options
                    disponibles. Avant de
                    finaliser un Ensemble de choix, TradeFan vérifiera que tous les jeux inclus n'ont pas encore
                    commencé. Si l'un
                    des jeux a déjà commencé, l'Ensemble de choix ne sera pas activé. Chaque Ensemble de choix doit
                    inclure des
                    joueurs de deux équipes différentes. Vous ne pouvez sélectionner un joueur qu'une seule fois, et
                    vous devez
                    faire des choix parmi des joueurs de deux (2) équipes différentes au minimum. Une fois qu'un joueur
                    est choisi,
                    il ne peut plus être sélectionné dans le même Ensemble de choix. Une fois l'Ensemble de choix
                    soumis, les
                    inscriptions ne peuvent plus être modifiées ni retirées.
                </p>
                <p>
                    TradeFan peut refuser d'accepter toute inscription à un concours, toute partie d'une inscription à
                    un concours,
                    vous interdire de participer à tout concours, ou vous interdire d'utiliser la plateforme TradeFan ou
                    les Services,
                    dans chaque cas, pour quelque raison que ce soit ou sans raison, à la seule et absolue discrétion de
                    TradeFan.
                    De plus, avant le début d'un concours, TradeFan peut annuler tout concours et/ou toute sélection
                    mise à
                    disposition pour créer votre Ensemble de choix, à sa seule et absolue discrétion, pour quelque
                    raison que ce soit
                    ou sans raison.
                </p>
                <p>
                    Dans le cas où votre Ensemble de choix est correctement inscrit à un ou plusieurs concours, pour
                    chaque concours
                    auquel votre Ensemble de choix est correctement inscrit, un dollar américain (1,00 $ US) sera débité
                    du solde de
                    votre compte. Dans le cas où vous disposez de fonds insuffisants sur votre compte, y compris, sans
                    limitation,
                    si un dépôt n'a pas été reçu par TradeFan avant que l'inscription au concours ne soit placée (par
                    exemple, un
                    dépôt est encore en cours de traitement par le processeur de paiement), une telle inscription peut
                    être annulée
                    par TradeFan à sa seule et absolue discrétion, pour quelque raison que ce soit ou sans raison. Une
                    inscription
                    à un concours n'est valide que lorsque l'inscription est acceptée par les serveurs de TradeFan, même
                    si cette
                    inscription apparaît dans votre section « Mes choix ». Il vous incombe de vérifier que tous les
                    détails et
                    sélections de votre Ensemble de choix et de votre inscription au concours sont complets et corrects
                    avant de
                    soumettre.
                </p>
                <p>
                    Les choix ne sont éligibles pour être comptés comme corrects que si le joueur sélectionné répond aux
                    exigences
                    minimales de participation, que vous ayez sélectionné « Plus » ou « Moins » pour ce choix.
                </p>
                <p>
                    Si un joueur n'est pas censé jouer, TradeFan peut rendre ce joueur indisponible pour la sélection.
                    Si un joueur
                    ne joue finalement pas, ses choix seront considérés comme nuls, votre Ensemble de choix sera annulé
                    et vos frais
                    d'inscription pour cet Ensemble de choix vous seront remboursés.
                </p>
                <p>
                    Si vous participez à un concours dans des circonstances suspectes, telles que déterminées par
                    TradeFan à sa seule
                    et absolue discrétion, pour quelque raison que ce soit ou sans raison, telles que la violation des
                    Accords,
                    l'inscription à trop de concours, la réalisation de sélections d'Ensembles de choix interconnectées
                    ou
                    l'inscription à des concours selon un modèle inhabituel, TradeFan peut suspendre votre compte,
                    annuler vos
                    inscriptions à des concours ou retenir des prix. Vous acceptez de fournir rapidement toute
                    information ou
                    coopération demandée par TradeFan dans le cadre de l'enquête sur des activités suspectes. Si vous ne
                    le faites
                    pas, vous acceptez de renoncer et de retourner tous les prix associés.
                </p>
                <p>
                    En participant à un concours ou en utilisant les Services ou la plateforme TradeFan, vous acceptez
                    de suivre les
                    décisions de TradeFan, qui sont prises à sa seule et absolue discrétion, pour toute raison ou sans
                    raison, et
                    sont définitives. Vous comprenez que vous n'avez aucun droit inhérent à utiliser la plateforme
                    TradeFan ou les
                    Services, et que TradeFan peut suspendre ou résilier votre compte à tout moment, pour toute raison.
                    TradeFan
                    peut refuser votre utilisation de la plateforme TradeFan, des Services ou de tout Service
                    spécifique, et peut
                    refuser des inscriptions à des concours, à sa seule et absolue discrétion. Si vous vous engagez dans
                    un
                    comportement que TradeFan juge inapproprié, frauduleux, suspect, de tricherie, malhonnête ou
                    déloyal, TradeFan
                    peut suspendre ou résilier votre compte, annuler les inscriptions, retenir les prix ou exiger le
                    retour des
                    prix. Les Parties Dégagées de TradeFan ne sont pas responsables de ces actions, et cela n'empêche
                    pas TradeFan de
                    poursuivre une action en justice.
                </p>
                <p>
                    SI UN CONCOURS NE PEUT SE DÉROULER COMME PRÉVU EN RAISON DE PROBLÈMES TECHNIQUES, DE MANIPULATION,
                    DE FRAUDE OU
                    D'AUTRES CAUSES, TRADEFAN, À SA SEULE ET ABSOLUE DISCRÉTION, PEUT ANNULER, TERMINER, MODIFIER OU
                    SUSPENDRE LE
                    CONCOURS. TOUTE TENTATIVE D'ENDOMMAGER LE SITE WEB OU DE PORTER ATTEINTE AU FONCTIONNEMENT LÉGITIME
                    D'UN CONCOURS
                    PEUT VIOLER LES LOIS, ET TRADEFAN SE RÉSERVE LE DROIT DE POURSUIVRE LES DOMMAGES ET AUTRES RECOURS
                    DANS TOUTE LA
                    MESURE PERMISE PAR LA LOI.
                </p>
            </section>
            <br/>
            <section id="contestWithdrawal">
                <p><strong>RETRAIT DU CONCOURS</strong></p>
                <p>
                    Vous pouvez être autorisé à vous retirer des concours dans certaines circonstances, telles que
                    déterminées par
                    TradeFan à sa seule et absolue discrétion, pour toute raison ou sans raison. Pour plus
                    d'informations sur le
                    retrait des concours et les situations dans lesquelles le retrait sera ou ne sera pas autorisé,
                    veuillez
                    consulter la section TradeFan PickX du Centre d'aide TradeFan disponible en cliquant <a
                    href="/help">ici</a>, qui est
                    intégrée dans son intégralité aux présentes Conditions d'utilisation par référence, y compris toute
                    modification
                    apportée à tout moment.
                </p>
            </section>
            <br/>
            <section id="limitationResposibilities">
                <p><strong>LIMITATION DES RESPONSABILITÉS DE TRADEFAN</strong></p>
                <p>
                    Les Parties Dégagées de TradeFan (telles que définies dans les présentes) ne sont pas responsables
                    de toute
                    information incorrecte, invalide ou inexacte ; des inscriptions incomplètes, incorrectes,
                    illisibles, non
                    intentionnelles ou mal dirigées ; des erreurs humaines ; des retards postaux ou des frais de port
                    dus ; des
                    dysfonctionnements ou défaillances techniques, tels que des pannes de services publics,
                    téléphoniques ou
                    Internet ; des omissions, interruptions, suppressions ou défauts dans les systèmes téléphoniques ou
                    Internet, les
                    systèmes informatiques, les données, les serveurs, les fournisseurs ou les logiciels (y compris les
                    logiciels ou
                    systèmes d'exploitation qui vous empêchent d'utiliser la plateforme TradeFan ou de participer à un
                    concours) ; de
                    tout dommage à votre ordinateur ou à celui d'une autre personne en raison de l'utilisation de la
                    plateforme
                    TradeFan ou des Services ; de l'incapacité d'accéder ou d'utiliser les Services ou toute page web
                    liée au site
                    Web ou à la plateforme TradeFan ; de problèmes tels que le vol, la manipulation ou l'accès non
                    autorisé à ou les
                    modifications de la plateforme TradeFan ou de votre compte ; des données traitées tardivement,
                    incorrectement ou
                    perdues en raison de problèmes téléphoniques, Internet ou postaux, de dysfonctionnements
                    informatiques ou de
                    congestion du trafic ; ou de toute erreur typographique, d'impression ou similaire.
                </p>
                <p>
                    TradeFan, à sa seule et absolue discrétion, peut suspendre ou résilier tout Service, Concours ou la
                    plateforme
                    TradeFan, ainsi que suspendre votre accès, résilier votre compte, annuler les inscriptions à des
                    concours,
                    retenir des prix ou exiger le retour des prix ou des fonds crédités à votre compte par erreur, même
                    si vous les
                    avez déjà retirés, pour toute raison ou sans raison. Cela peut se produire si :
                </p>
                <ul>
                    <li>Il y a une erreur évidente avec un concours, telle que des statistiques incorrectes ou si
                        l'événement a déjà
                        commencé ou s'est produit.
                    </li>
                    <li>Une sélection est incorrectement comptabilisée en votre faveur.</li>
                    <li>Des fonds sont crédités sur votre compte par erreur.</li>
                    <li>Un virus, un bug, une manipulation ou une défaillance technique empêche la plateforme TradeFan
                        ou les
                        Services de fonctionner correctement ou affecte l'équité et l'intégrité de la plateforme
                        TradeFan, des
                        concours ou des Services.
                    </li>
                </ul>
                <p>
                    Vous devez immédiatement informer TradeFan et cesser d'utiliser les Services et la plateforme si
                    vous prenez
                    connaissance de toute erreur liée aux Services, à la plateforme, aux concours ou à votre compte, y
                    compris les
                    fonds crédités par erreur sur votre compte. Tous les montants ou prix crédités sur votre compte par
                    erreur sont
                    détenus en fiducie pour TradeFan et doivent être retournés sur demande, même si vous les avez déjà
                    retirés.
                    TradeFan se réserve également le droit de récupérer directement sur votre compte tout fonds ou prix
                    crédité par
                    erreur.
                </p>
                <p>
                    TOUTE TENTATIVE DE VOTRE PART OU DE TOUTE AUTRE PERSONNE DE DÉTÉRIORER LA PLATEFORME TRADEFAN OU LES
                    SERVICES OU
                    DE COMPROMETTRE LEUR FONCTIONNEMENT LÉGITIME EST UNE VIOLATION DES PRÉSENTES CONDITIONS
                    D'UTILISATION ET PEUT
                    ÉGALEMENT ENTRAÎNER UNE VIOLATION DES LOIS PÉNALES ET/OU CIVILES. SI UNE TELLE TENTATIVE EST FAITE,
                    TRADEFAN SE
                    RÉSERVE LE DROIT DE DEMANDER DES DOMMAGES-INTÉRÊTS ET D'AUTRES RECOURS DANS TOUTE LA MESURE PERMISE
                    PAR LA LOI.
                </p>
                <p>
                    Vous ne pouvez utiliser la plateforme TradeFan et les Services que de la manière spécifiée dans les
                    Accords. Le
                    non-respect des Accords peut entraîner, sans limitation, la suspension et/ou la résiliation de votre
                    compte,
                    l'annulation ou l'invalidation de toute inscription à un concours en attente, la retenue de tout
                    prix et/ou le
                    retour de tout prix.
                </p>
            </section>
            <br/>
            <section id="howPick12Works">
                <p><strong>COMMENT FONCTIONNE UN CONCOURS PICK-12 ?</strong></p>
                <p>
                    Répondez correctement à autant de questions que possible parmi les 12 questions de plus/moins, et
                    consultez le
                    schéma des prix suivant pour réclamer le prix correspondant à votre score :
                </p>
                <PayoutDistributionTable payoutInfos={new Pick12PayoutCalculator().calculateDistribution(5)}
                                         currency={GlobalConst.SITE_CURRENCY}/>
            </section>
            <br/>
            <section id="howPick16Works">
                <p><strong>COMMENT FONCTIONNE UN CONCOURS PICK-16 ?</strong></p>
                <p>
                    Répondez correctement à autant de questions que possible parmi les 16 questions de plus/moins, et
                    consultez le
                    schéma des prix suivant pour réclamer le prix correspondant à votre score :
                </p>
                <PayoutDistributionTable payoutInfos={new Pick16PayoutCalculator().calculateDistribution(5)}
                                         currency={GlobalConst.SITE_CURRENCY}/>
            </section>
            <br/>
            <section id="grantOfLicense">
                <p><strong>OCTROI DE LICENCE</strong></p>
                <p>
                    Sauf si la loi l'interdit, en utilisant les Services ou la plateforme TradeFan, en participant à des
                    concours ou
                    en acceptant tout prix, vous accordez à TradeFan et à ses affiliés le droit mondial, perpétuel,
                    irrévocable,
                    valable pour toute l'entreprise et sans redevance d'utiliser votre nom, pseudonyme, photographie,
                    image,
                    déclarations, informations biographiques, voix, ville et état de résidence, et autres informations
                    identifiantes, dans tous les types de médias, actuels ou futurs, à des fins publicitaires et
                    promotionnelles
                    liées à la plateforme TradeFan, aux Services, à TradeFan ou à ses affiliés, et/ou aux autres
                    produits et services
                    de TradeFan et de ses affiliés, sans aucune contrepartie supplémentaire, compensation, notification,
                    révision,
                    approbation ou autorisation. Vous acceptez par les présentes de signer toute décharge publicitaire
                    exigée par
                    TradeFan.
                </p>
            </section>
            <br/>
            <section id="promotions">
                <p><strong>PROMOTIONS</strong></p>
                <p>
                    Sauf si la loi l'interdit, en utilisant les Services ou la plateforme TradeFan, en participant à des
                    concours ou
                    en acceptant tout prix, vous accordez à TradeFan et à ses affiliés le droit mondial, perpétuel,
                    irrévocable,
                    valable pour toute l'entreprise et sans redevance d'utiliser votre nom, pseudonyme, photographie,
                    image,
                    déclarations, informations biographiques, voix, ville et état de résidence, et autres informations
                    identifiantes, dans tous les types de médias, actuels ou futurs, à des fins publicitaires et
                    promotionnelles
                    liées à la plateforme TradeFan, aux Services, à TradeFan ou à ses affiliés, et/ou aux autres
                    produits et services
                    de TradeFan et de ses affiliés, sans aucune contrepartie supplémentaire, compensation, notification,
                    révision,
                    approbation ou autorisation. Vous acceptez par les présentes de signer toute décharge publicitaire
                    exigée par
                    TradeFan.
                </p>
                <p>
                    Les Accords s'appliquent à toutes les promotions, bonus, réalisations ou offres similaires liés aux
                    Services
                    et/ou à la plateforme TradeFan. Chaque promotion, bonus, mission ou offre similaire peut comporter
                    des
                    conditions supplémentaires, des règles et/ou des exigences d'éligibilité. Ceux-ci seront soit (i)
                    publiés sur la
                    plateforme TradeFan et/ou les Services et deviendront immédiatement contraignants, qu'ils vous
                    soient
                    directement communiqués ou non, soit (ii) communiqués d'une autre manière. Ces conditions, règles
                    et/ou
                    exigences supplémentaires sont intégrées dans leur intégralité aux présentes Conditions
                    d'utilisation par
                    référence, y compris toute modification future qui leur sera apportée.
                </p>
                <p>
                    En participant à toute promotion, bonus, réalisation ou offre similaire, ou en réclamant ou
                    acceptant tout prix
                    ou récompense, vous acceptez toutes les conditions, règles et/ou exigences d'éligibilité de cette
                    offre, qui sont
                    également intégrées dans les présentes Conditions d'utilisation par référence, y compris toute
                    modification. Si
                    vous n'acceptez pas les conditions, règles et/ou exigences d'éligibilité, ne participez pas et
                    n'acceptez pas
                    de prix ou de récompense.
                </p>
                <p>
                    En cas de conflit entre les présentes Conditions et les conditions distinctes d'une promotion
                    spécifique, d'un
                    bonus, d'une réalisation ou d'une offre similaire, les conditions spécifiques de la promotion ou de
                    l'offre
                    prévaudront. Rien dans les Accords ne modifie ou n'invalide ces conditions distinctes.
                </p>
                <p>
                    TradeFan se réserve le droit de vous empêcher de participer à toute promotion, bonus, réalisation ou
                    offre
                    similaire pour toute raison ou sans raison, à sa seule et absolue discrétion. Vous êtes entièrement
                    responsable
                    de lire et de comprendre les conditions et exigences de toute promotion à laquelle vous participez.
                </p>
            </section>
            <br/>
            <section id="responsibleGaming">
                <p><strong>JEU RESPONSABLE</strong></p>
                <p>
                    Des informations sur le jeu responsable, y compris les options d'auto-exclusion et
                    d'auto-limitation, sont
                    disponibles à : <a href={`${responsibleGamingTexts.link}`}>{responsibleGamingTexts.title}</a>
                </p>
            </section>
            <br/>
            <section id="statisticsAndLiveScoring">
                <p>
                    Toutes les statistiques, résultats, actualités et autres informations fournies sur la plateforme
                    TradeFan ou les
                    Services, y compris les statistiques « en direct », sont officieuses, peuvent ne pas être à jour et
                    sont
                    fournies EN L'ÉTAT à des fins d'information et de divertissement uniquement. Vous ne devez pas vous
                    fier à ces
                    statistiques, résultats, actualités ou autres informations à quelque fin que ce soit, y compris pour
                    prendre des
                    décisions de concours ou d'Ensemble de choix. Ces statistiques et résultats peuvent également
                    différer de ceux
                    utilisés officiellement pour déterminer l'issue des sélections d'Ensemble de choix et/ou des
                    concours.
                </p>
                <p>
                    Les Parties Dégagées de TradeFan ou tout fournisseur tiers ne garantissent ni ne font de
                    déclarations quant à
                    l'exactitude ou à la fiabilité des statistiques, résultats, actualités ou autres informations
                    fournies via la
                    plateforme TradeFan, les Services ou des sources connexes. Les Parties Dégagées de TradeFan et les
                    fournisseurs
                    tiers ne sont pas responsables de l'exactitude, de l'utilité ou de la disponibilité de ces
                    informations et ne
                    seront pas tenus responsables de toute erreur ou omission dans les statistiques, les actualités, les
                    résultats ou
                    d'autres informations fournies.
                </p>
            </section>
            <br/>
            <section id="results">
                <p><strong>RÉSULTATS</strong></p>
                <p>
                    Les concours proposés via les Services et/ou la plateforme TradeFan sont des concours de compétence.
                    Les
                    gagnants sont déterminés en fonction de la compétence et des connaissances du participant, y
                    compris, sans
                    limitation, en ce qui concerne les informations sportives pertinentes et les règles du concours. Les
                    Services,
                    la plateforme TradeFan et/ou les concours ne peuvent pas être utilisés pour toute forme de jeu
                    illicite.
                </p>
                <p>
                    Les concours sont évalués en fonction du nombre de sélections correctes dans votre Ensemble de choix
                    pour ce
                    concours. Les résultats des concours sont basés sur les statistiques et les résultats finaux à la
                    fin des jeux,
                    concours, matchs ou événements associés au concours. À la fin du dernier jeu, concours, match ou
                    événement
                    associé au concours, les résultats sont examinés, les inscriptions sont évaluées et les prix sont
                    attribués. Les
                    résultats et statistiques finaux ne seront pas modifiés, quelles que soient les corrections
                    statistiques
                    officielles ou les ajustements de scores effectués ultérieurement, sauf à la seule et absolue
                    discrétion de
                    TradeFan, pour toute raison ou sans raison. Dans le cas où un ou plusieurs jeux, concours, matchs ou
                    événements
                    associés à un concours sont annulés, reportés ou reprogrammés, aux fins du concours, cette
                    annulation, ce report
                    ou cette reprogrammation sera traité conformément aux règles du concours pour le concours applicable
                    (disponibles
                    dans l'onglet Règles des concours sur la page Détails du concours concerné), qui sont intégrées dans
                    leur
                    intégralité aux présentes Conditions d'utilisation par référence, y compris toute modification
                    apportée à tout
                    moment.
                </p>
            </section>
            <br/>
            <section id="paymentAndWithdrawal">
                <p><strong>PAIEMENT ET RETRAIT</strong></p>
                <p>
                    Avant de vous remettre un prix quelconque, TradeFan peut vous demander de remplir un affidavit
                    confirmant votre
                    éligibilité et libérant TradeFan de toute réclamation. Vous devez également confirmer que vous êtes
                    éligible à
                    utiliser les Services, à respecter les Accords et à fournir des documents prouvant votre identité et
                    votre
                    éligibilité, y compris en remplissant des formulaires fiscaux. Si TradeFan le demande et que vous ne
                    fournissez
                    pas ces informations dans un délai de sept (7) jours, ou si TradeFan décide que vous ne remplissez
                    pas les
                    exigences ou que vous ne respectez pas les Accords, ils peuvent retenir ou reprendre tout prix, et
                    ils peuvent
                    suspendre ou résilier votre compte et l'accès aux Services.
                </p>
                <p>
                    Sous réserve de la vérification par TradeFan de votre conformité aux Accords et à toute autre
                    condition de
                    participation, les gains de votre Ensemble de choix seront traités après que les deux conditions
                    suivantes se
                    soient produites :
                </p>
                <ol>
                    <li>
                        Chaque jeu de l'Ensemble de choix est terminé, ce qui peut inclure des jeux pour lesquels vous
                        n'avez pas fait
                        de choix ; et
                    </li>
                    <li>
                        TradeFan a finalisé les statistiques de chaque jeu de l'Ensemble de choix pour confirmer leur
                        exactitude avec
                        le score officiel des ligues respectives, généralement à la fin de la nuit.
                    </li>
                </ol>
                <p>
                    Pour cette raison, il peut y avoir un délai entre le moment où vos choix sont finalisés et celui où
                    les gains
                    sont traités sur votre compte.
                </p>
                <p>
                    Tous les impôts associés à la réception de tout prix sont de la seule responsabilité du gagnant.
                    TradeFan peut
                    déclarer les prix à l'agence fiscale de l'état concerné et/ou à l'Internal Revenue Service et/ou
                    retenir une
                    partie de votre prix en fonction du montant brut ou net gagné. TradeFan remettra toute partie de
                    votre prix
                    retenue à des fins fiscales à l'Internal Revenue Service et/ou à l'agence fiscale de l'état
                    concerné, conformément
                    à la législation en vigueur.
                </p>
                <p>
                    Pour mettre à jour vos informations de contact, vous pouvez les modifier dans votre compte ou
                    demander des
                    modifications en envoyant un e-mail à <a href='mailto:support@TradeFan.com'>support@TradeFan.com</a>
                </p>
                <p>
                    Dans le cas où l'attribution de tout prix est contestée par une autorité légale, TradeFan se réserve
                    le droit de
                    déterminer, à sa seule et absolue discrétion, pour toute raison ou sans raison, s'il convient ou non
                    d'attribuer
                    ce prix. Dans le cas où vous gagnez un montant ou un prix supérieur à une certaine valeur, et que
                    vous devez des
                    montants à l'état, y compris, sans limitation, des arriérés de pension alimentaire ou des impôts
                    impayés, TradeFan
                    peut suspendre votre compte, vous empêcher d'effectuer des retraits depuis votre compte et/ou
                    retenir et remettre
                    tout prix ou une partie de celui-ci, conformément à la législation en vigueur. Aucun remplacement ou
                    transfert de
                    tout prix n'est autorisé, sauf que TradeFan se réserve le droit, à sa seule et absolue discrétion,
                    pour toute
                    raison ou sans raison, de substituer un prix d'une valeur égale ou supérieure. Tous les prix sont
                    attribués « en
                    l'état » et sans aucune garantie, expresse ou implicite, y compris, sans limitation, toute garantie
                    implicite de
                    qualité marchande ou d'utilisation à des fins particulières.
                </p>
            </section>
            <br/>
            <section id="termination">
                <p><strong>RÉSILIATION ET EFFET DE LA RÉSILIATION</strong></p>
                <p>
                    Vous pouvez fermer définitivement votre compte à tout moment pour n'importe quelle raison en
                    envoyant un e-mail
                    à <a href='mailto:support@TradeFan.com'>support@TradeFan.com</a>
                </p>
                <p>
                    TradeFan peut immédiatement suspendre ou résilier les Services, Concours, la plateforme TradeFan ou
                    toute
                    fonctionnalité ou fonction au sein des Services ou de la plateforme à tout moment, sans préavis, à
                    sa seule et
                    absolue discrétion, pour toute raison ou sans raison. Si TradeFan met fin aux Services, ils peuvent
                    rembourser le
                    solde de votre compte moins tout bonus non utilisé, toute inscription gratuite ou crédit
                    promotionnel, qui sera
                    perdu.
                </p>
                <p>
                    De plus, TradeFan peut, sans préavis et à sa seule discrétion, pour toute raison ou sans raison,
                    fermer votre
                    compte, désactiver votre (vos) mot(s) de passe, vous refuser l'accès à la plateforme TradeFan et aux
                    Services,
                    annuler toute inscription à un concours en attente et/ou résilier tous les droits accordés en vertu
                    des Accords.
                    Si cela se produit, vous devez immédiatement cesser d'utiliser la plateforme TradeFan et les
                    Services. Les
                    Parties Dégagées de TradeFan ne sont pas responsables de la suspension ou de la résiliation des
                    Services, des
                    concours, de la plateforme TradeFan ou de toute fonctionnalité, ni de la résiliation ou suspension
                    de votre compte.
                </p>
                <p>
                    La fermeture de votre compte ou la résiliation des Services, Concours, plateforme ou de tout droit
                    accordé en
                    vertu des Accords n'affecte pas les droits, obligations ou responsabilités survenus avant cela.
                    Toutes les parties
                    des Accords qui doivent se poursuivre après la fermeture de votre compte ou la résiliation des
                    Services ou droits,
                    telles que les dispositions de propriété, les exclusions de garantie, l'indemnité et la limitation
                    de
                    responsabilité, resteront en vigueur.
                </p>
            </section>
            <br/>
            <section id="disclaimer">
                <p><strong>EXCLUSION DE GARANTIES</strong></p>
                <p>
                    TOUS LES CONTENUS, LOGICIELS ET FONCTIONNALITÉS SUR LA PLATEFORME TRADEFAN, LES CONCOURS ET LES
                    SERVICES SONT
                    FOURNIS « EN L'ÉTAT », « SELON LA DISPONIBILITÉ » ET « AVEC TOUS LES DÉFAUTS ». VOTRE UTILISATION DE
                    LA PLATEFORME
                    TRADEFAN ET VOTRE PARTICIPATION À TOUT CONCOURS SE FONT À VOS PROPRES RISQUES. LES PARTIES DÉGAGÉES
                    DE TRADEFAN
                    EXCLUENT TOUTE GARANTIE, QU'ELLE SOIT EXPRESSE OU IMPLICITE, Y COMPRIS LES GARANTIES DE
                    NON-VIOLATION, DE
                    QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER ET DE TITRE.
                </p>
                <p>
                    LES PARTIES DÉGAGÉES DE TRADEFAN NE FONT AUCUNE GARANTIE CONCERNANT :
                </p>
                <ul>
                    <li>LA PROPRIÉTÉ INTELLECTUELLE, LA PLATEFORME, LES CONCOURS OU LES SERVICES.</li>
                    <li>L'EXACTITUDE OU L'EXHAUSTIVITÉ DU CONTENU ET DES LOGICIELS SUR LA PLATEFORME TRADEFAN OU LES
                        SERVICES.
                    </li>
                    <li>LA FONCTIONNALITÉ DE LA PLATEFORME OU DES SERVICES TRADEFAN.</li>
                    <li>LES MESSAGES OU INFORMATIONS ENVOYÉS VIA LA PLATEFORME TRADEFAN OU PAR D'AUTRES UTILISATEURS.
                    </li>
                    <li>TOUT PRODUIT OU SERVICE OFFERT VIA LA PLATEFORME TRADEFAN, Y COMPRIS LES PRODUITS TIERS.</li>
                    <li>LES LIENS VERS DES SITES WEB OU APPLICATIONS TIERS.</li>
                    <li>LA SÉCURITÉ DE TOUTE INFORMATION SENSIBLE TRANSMISE VIA LA PLATEFORME TRADEFAN OU LES SERVICES,
                        OU VERS DES
                        SITES TIERS QUI Y SONT LIÉS.
                    </li>
                </ul>
                <p>
                    TRADEFAN NE GARANTIT PAS QUE LA PLATEFORME TRADEFAN OU LES SERVICES SERONT ININTERROMPUS, SANS
                    ERREUR, TOUJOURS
                    DISPONIBLES OU EXEMPTS DE VIRUS OU D'ÉLÉMENTS NUISIBLES, OU QUE LES DÉFAUTS SERONT CORRIGÉS.
                </p>
                <p>
                    LES PARTIES DÉGAGÉES DE TRADEFAN NE SONT PAS RESPONSABLES DE LA LÉGALITÉ DE VOTRE UTILISATION DE LA
                    PLATEFORME
                    TRADEFAN OU DE VOTRE PARTICIPATION AUX CONCOURS DANS VOTRE LOCALISATION. IL VOUS INCOMBE DE VOUS
                    ASSURER QUE VOS
                    ACTIVITÉS SONT LÉGALES LÀ OÙ VOUS UTILISEZ LA PLATEFORME TRADEFAN OU LES SERVICES, ET VOUS LE FAITES
                    À VOS PROPRES
                    RISQUES.
                </p>
            </section>
            <section id="indemnification">
                <p><strong>INDEMNISATION</strong></p>
                <p>
                    En utilisant la plateforme TradeFan, en participant à un concours, en utilisant les Services ou en
                    acceptant
                    tout prix, vous acceptez d'indemniser, de dégager de toute responsabilité et de tenir indemnes les
                    Parties
                    Dégagées de TradeFan de toute responsabilité, réclamation, dommage, perte, coût ou dépense (y
                    compris les frais
                    d'avocat, frais de justice et frais juridiques) résultant : (i) de votre participation aux concours
                    ou de votre
                    utilisation des Services ou de la plateforme TradeFan, y compris des déplacements pour ou la
                    participation à des
                    événements ou activités liés à la plateforme TradeFan ; (ii) de votre réception, possession,
                    utilisation ou
                    mauvaise utilisation de tout prix, et de votre participation ou de celle de vos invités à tout
                    événement lié à un
                    prix, y compris des déplacements vers ou depuis ces événements ; (iii) de votre violation des
                    Accords ; (iv) de
                    votre utilisation des Services ou de la plateforme TradeFan en violation de toute loi ou
                    réglementation ; (v) de
                    tout financement de votre compte, y compris la méthode de paiement utilisée ; (vi) de votre
                    utilisation de la
                    plateforme TradeFan, des Services ou de la Propriété Intellectuelle d'une manière qui viole ou
                    enfreint les droits
                    de tiers, y compris les brevets, droits d'auteur, marques de commerce, droits de publicité ou droits
                    à la vie
                    privée ; (vii) de vos droits de publicité ou de vie privée ; et (viii) de toute information que vous
                    soumettez à
                    TradeFan, y compris des informations fausses ou trompeuses ou des fausses déclarations.
                </p>
                <p>
                    Ceux-ci sont appelés « Réclamations d'Indemnisation ». TradeFan se réserve le droit de contrôler la
                    défense ou le
                    règlement de toute Réclamation d'Indemnisation sans votre consentement. Vous acceptez de coopérer et
                    de fournir
                    toute information ou assistance demandée par TradeFan pendant la défense ou le règlement de ces
                    réclamations.
                    Vous acceptez également de ne pas régler toute Réclamation d'Indemnisation ni de faire de
                    déclarations susceptibles
                    d'affecter la défense de TradeFan sans leur consentement préalable par écrit.
                </p>
            </section>
            <br/>
            <section id="limitationLiability">
                <p><strong>LIMITATION DE RESPONSABILITÉ</strong></p>
                <p>
                    VOUS COMPRENEZ ET ACCEPTEZ QUE LES PARTIES DÉGAGÉES DE TRADEFAN LIMITENT LEUR RESPONSABILITÉ
                    CONCERNANT VOTRE
                    PARTICIPATION AUX CONCOURS OU VOTRE UTILISATION DES SERVICES ET DE LA PLATEFORME TRADEFAN, PEU
                    IMPORTE SI LE
                    PROBLÈME EST DÛ À UN CONTRAT, À LA NÉGLIGENCE, À LA RESPONSABILITÉ STRICTE OU À UNE RESPONSABILITÉ
                    DÉLICTUELLE
                    (Y COMPRIS DES CAUSES COMME LA NÉGLIGENCE, LES ACTES DE DIEU, LES PANNES DE TÉLÉCOMS OU LE VOL). LES
                    PARTIES
                    DÉGAGÉES DE TRADEFAN NE SONT PAS RESPONSABLES DES PERTES OU DOMMAGES DE TOUT TYPE, Y COMPRIS LES
                    DOMMAGES
                    SPÉCIAUX, DIRECTS, INDIRECTS, INCIDENTS OU PUNITIFS, LIÉS À :
                </p>
                <ol>
                    <li>
                        LA PLATEFORME TRADEFAN, LES SERVICES, LES CONCOURS, LA PROPRIÉTÉ INTELLECTUELLE OU TOUT CONTENU
                        SUR LA PLATEFORME
                        TRADEFAN.
                    </li>
                    <li>
                        L'UTILISATION, L'IMPOSSIBILITÉ D'UTILISER OU LES PERFORMANCES DES SERVICES OU DE LA PLATEFORME,
                        Y COMPRIS LES
                        CONCOURS.
                    </li>
                    <li>
                        TOUTES ACTIONS ENTREPRISES PAR TRADEFAN OU LES FORCES DE L'ORDRE CONCERNANT VOTRE PARTICIPATION
                        AUX CONCOURS OU
                        VOTRE UTILISATION DE LA PLATEFORME TRADEFAN OU DES SERVICES.
                    </li>
                    <li>
                        LES ACTIONS ENTREPRISES EN LIEN AVEC LES RÉCLAMATIONS RELATIVES AUX DROITS D'AUTEUR.
                    </li>
                    <li>
                        TOUTES ERREURS OU PROBLÈMES DANS LES CONCOURS OU LE FONCTIONNEMENT TECHNIQUE DE LA PLATEFORME
                        TRADEFAN OU DES
                        SERVICES.
                    </li>
                </ol>
                <p>
                    MÊME SI CES DOMMAGES ÉTAIENT PRÉVISIBLES OU SI LES PARTIES DÉGAGÉES DE TRADEFAN AVAIENT ÉTÉ AVERTIES
                    DE LA
                    POSSIBILITÉ DE TELS DOMMAGES, ILS NE SONT TOUJOURS PAS RESPONSABLES. CERTAINS ÉTATS PEUVENT NE PAS
                    PERMETTRE
                    CETTE LIMITATION DES DOMMAGES, ELLE POURRAIT DONC NE PAS S'APPLIQUER À VOUS. DANS TOUS LES CAS, LA
                    RESPONSABILITÉ
                    MAXIMALE DES PARTIES DÉGAGÉES DE TRADEFAN POUR TOUTES RÉCLAMATIONS NE DÉPASSERA PAS 100 $.
                </p>
                <p>
                    VOUS ACCEPTEZ ÉGALEMENT DE RENONCER À VOTRE DROIT À UN PROCÈS DEVANT JURY POUR TOUTES RÉCLAMATIONS.
                </p>
                <p>
                    SI VOUS N'ÊTES PAS SATISFAIT DE LA PLATEFORME TRADEFAN OU DES SERVICES, VOTRE SEULE OPTION EST
                    D'ARRÊTER DE LES
                    UTILISER. SI VOUS SUBISSEZ DES DOMMAGES OU DES PERTES DUS AUX ACTIONS DES PARTIES DÉGAGÉES DE
                    TRADEFAN, CEUX-CI
                    NE SONT PAS ASSEZ GRAVES POUR JUSTIFIER D'EMPÊCHER TRADEFAN DE POURSUIVRE SES ACTIVITÉS, Y COMPRIS
                    LE DÉVELOPPEMENT,
                    LA PRODUCTION OU LA DISTRIBUTION DE SES SERVICES OU PRODUITS.
                </p>
                <p>
                    EN PARTICIPANT À DES CONCOURS OU EN UTILISANT LA PLATEFORME OU LES SERVICES TRADEFAN, VOUS COMPRENEZ
                    QUE VOUS
                    POUVEZ RENONCER À DES DROITS LIÉS À DES RÉCLAMATIONS ACTUELLEMENT INCONNUES. VOUS ACCEPTEZ DE
                    RENONCER AUX
                    AVANTAGES DE TOUTE LOI (COMME LA SECTION 1542 DU CODE CIVIL DE LA CALIFORNIE OU TOUTE LOI SIMILAIRE
                    OU ÉQUIVALENTE
                    DANS D'AUTRES ÉTATS) QUI POURRAIT AUTREMENT LIMITER VOTRE RENONCIATION À DE TELLES RÉCLAMATIONS.
                </p>
            </section>
            <br/>
            <section id="intellectualPropertyRights">
                <p><strong>DROITS DE PROPRIÉTÉ INTELLECTUELLE</strong></p>
                <p>
                    La plateforme TradeFan, les Services et tout contenu qui s'y trouve — tel que le texte, les
                    logiciels, les
                    données, les graphiques, les photos, les vidéos, les conceptions et les marques déposées (désignés
                    sous le nom de
                    « <strong>Propriété Intellectuelle</strong> ») — sont la propriété de ou sous licence de TradeFan et
                    protégés par les lois
                    américaines et internationales. TradeFan vous accorde un droit limité, non transférable, révocable
                    et non exclusif
                    d'utiliser la plateforme TradeFan, les Services et la Propriété Intellectuelle à des fins
                    personnelles et non
                    commerciales uniquement. Vous ne pouvez pas copier, reproduire, distribuer, afficher, vendre ou
                    modifier une
                    partie quelconque de cette Propriété Intellectuelle sans l'autorisation préalable écrite de
                    TradeFan.
                </p>
                <p>
                    Il vous est interdit d'inverser l'ingénierie, de modifier ou de tenter d'accéder au code source de
                    la plateforme
                    ou des Services TradeFan. Vous ne pouvez pas supprimer ou altérer les droits d'auteur, les marques
                    déposées ou
                    d'autres avis légaux figurant sur la plateforme TradeFan. TradeFan se réserve tous les droits qui ne
                    vous sont pas
                    expressément accordés et peut résilier votre utilisation de sa Propriété Intellectuelle à tout
                    moment, pour toute
                    raison. De plus, vous ne devez pas interférer avec les fonctionnalités qui empêchent l'utilisation
                    ou la copie
                    non autorisée de la Propriété Intellectuelle de TradeFan.
                </p>
            </section>
            <br/>
            <section id="jurisdictionAndGoverningLaw">
                <p><strong>JURIDICTION ET DROIT APPLICABLE</strong></p>
                <p>
                    Si vous avez des questions, préoccupations ou plaintes concernant la plateforme TradeFan ou les
                    Services, veuillez
                    envoyer un e-mail au service client de TradeFan à <a
                    href='mailto:support@TradeFan.com'>support@TradeFan.com</a>.
                    Vous acceptez de faire des efforts raisonnables et de bonne foi pour résoudre tout différend,
                    réclamation ou
                    controverse avec TradeFan par l'intermédiaire de leur service client avant d'engager une action en
                    justice.
                </p>
                <p>
                    Les Accords seront régis par les lois internes du Québec, Canada, sans référence à ses principes de
                    conflit de
                    lois ou à toute autre loi qui exigerait l'application des lois d'une autre juridiction. La
                    juridiction et le lieu
                    exclusifs pour tout différend, réclamation, cause d'action ou controverse liés aux Accords ou à
                    l'utilisation de
                    la plateforme TradeFan ou des Services (« Réclamations ») seront les tribunaux de juridiction
                    compétente situés au
                    Québec, Canada (le « Forum »). Vous renoncez irrévocablement à tout argument selon lequel ces
                    tribunaux manquent de
                    compétence personnelle ou que ce Forum est inapproprié ou inconfortable. Si vous engagez une
                    procédure dans une
                    autre juridiction, vous acceptez que TradeFan récupère auprès de vous tous les frais d'avocat et
                    frais encourus
                    raisonnablement pour faire appliquer cet accord de Forum. De plus, vous renoncez à tout droit à un
                    procès devant
                    jury pour toute Réclamation.
                </p>
                <p>
                    Vous acceptez, dans toute la mesure permise par la loi applicable, que toute Réclamation doit être
                    engagée dans un
                    délai d'un (1) an à compter de la date de naissance de la cause d'action pour cette Réclamation, ou
                    vous renoncez
                    irrévocablement à cette Réclamation et êtes définitivement interdit de l'exercer.
                </p>
            </section>
            <br/>
            <section id="miscellaneous">
                <p><strong>DIVERS</strong></p>
                <p>
                    Rien dans les Accords ne confère de droits ou d'avantages à des tiers, sauf mention spécifique.
                </p>
                <p>
                    Vous ne pouvez pas transférer ou céder vos droits en vertu des Accords, y compris votre compte, à
                    quiconque sans
                    l'autorisation écrite de TradeFan. TradeFan, cependant, peut transférer ou céder les Accords, votre
                    compte ou ses
                    droits et obligations à toute société affiliée ou à un tiers sans votre consentement ni vous en
                    informer.
                </p>
                <p>
                    La plateforme TradeFan ou les Services peuvent contenir des liens vers des sites Web tiers, mais
                    TradeFan n'a
                    aucun contrôle sur ces sites et n'est pas responsable de leur contenu, de leurs politiques de
                    confidentialité ou
                    de leurs pratiques. TradeFan n'éditera pas ou ne contrôlera pas non plus le contenu sur ces sites.
                    En utilisant la
                    plateforme TradeFan ou en participant à des concours, vous libérez les Parties Dégagées de TradeFan
                    de toute
                    responsabilité liée à votre utilisation des sites Web tiers. TradeFan vous conseille de lire les
                    conditions et
                    politiques des sites tiers que vous visitez, car vous les utilisez à vos propres risques.
                </p>
                <p>
                    Il peut également y avoir des publicités de tiers sur la plateforme TradeFan, mais TradeFan ne
                    cautionne ni ne
                    garantit aucun de ces produits ou services. Vous êtes responsable de toute transaction que vous
                    effectuez avec
                    des annonceurs tiers, et TradeFan ne sera pas responsable des pertes ou dommages résultant de ces
                    interactions.
                    Vous acceptez d'indemniser et de dégager de toute responsabilité les Parties Dégagées de TradeFan
                    pour toute
                    réclamation ou responsabilité découlant de votre utilisation de produits ou services tiers annoncés
                    sur la
                    plateforme TradeFan.
                </p>
                <p>
                    Rien dans les Accords n'établit de partenariat ou de coentreprise entre vous et TradeFan.
                </p>
                <p>
                    Les éditeurs en ligne tiers qui renvoient des utilisateurs à la plateforme TradeFan ne sont pas non
                    plus
                    responsables du contenu ou des services de la plateforme TradeFan. Vous acceptez également
                    d'indemniser les
                    Parties Dégagées de TradeFan pour toute responsabilité ou réclamation liée à ces éditeurs tiers.
                </p>
                <p>
                    Toute renonciation à un terme doit être faite par écrit, et une renonciation unique ne signifie pas
                    des
                    renonciations futures. Si une partie des Accords est jugée invalide, le reste restera exécutoire.
                </p>
                <p>
                    TradeFan peut modifier les Accords à tout moment sans préavis, et il vous incombe de vérifier les
                    mises à jour.
                    La poursuite de l'utilisation de la plateforme TradeFan signifie que vous acceptez toutes les
                    modifications. Si
                    vous n'acceptez pas les modifications, vous devez fermer votre compte.
                </p>
                <p>
                    TradeFan ne sera pas responsable du non-respect de toute obligation en vertu des Accords si cela est
                    dû à des
                    causes échappant à son contrôle, telles que des catastrophes naturelles, la guerre, les pandémies ou
                    d'autres
                    urgences.
                </p>
                <p>
                    Enfin, l'utilisation des Services sur votre appareil sans fil peut entraîner des frais de données de
                    la part de
                    votre opérateur, dont vous êtes responsable.
                </p>
            </section>
            <br/>

            <h1>OÙ POUVEZ-VOUS JOUER À TRADEFAN PICKX ?</h1>
            <h2>TradeFan PickX est disponible dans les États américains et les provinces/territoires canadiens suivants
                :</h2>
            <PickXProvincesAndTerritories/>
        </div>
    );
}

export default TermsOfUseFr;